export default __webpack_public_path__ + "static/media/Search.56b3ee56.svg";